import { toast } from "sonner";
import { Copy, Images, Instagram, MessageCircle, Share2, Waves } from "lucide-react";
import { mediaUrl } from "@/lib/pricing";

// Airbnb-style mosaic that adapts to the number of photos.
export const AdaptiveGallery = ({ images, title, onOpen, testId }) => {
  const imgs = (images || []).slice(0, 5);
  if (!imgs.length) return <div className="h-72 rounded-[2rem] bg-cyan-50 flex items-center justify-center text-cyan-300"><Waves size={48} /></div>;
  const n = imgs.length;
  const layout = {
    1: ["col-span-4 row-span-2"],
    2: ["col-span-4 sm:col-span-2 row-span-2", "hidden sm:block sm:col-span-2 row-span-2"],
    3: ["col-span-4 sm:col-span-2 row-span-2", "hidden sm:block sm:col-span-2", "hidden sm:block sm:col-span-2"],
    4: ["col-span-4 sm:col-span-2 row-span-2", "hidden sm:block sm:col-span-2", "hidden sm:block", "hidden sm:block"],
    5: ["col-span-4 sm:col-span-2 row-span-2", "hidden sm:block", "hidden sm:block", "hidden sm:block", "hidden sm:block"],
  }[n];
  return (
    <div className="relative">
      <div className="grid grid-cols-4 grid-rows-2 gap-2 h-[300px] sm:h-[460px] rounded-[2rem] overflow-hidden" data-testid={testId}>
        {imgs.map((src, i) => (
          <button key={src + i} onClick={() => onOpen(i)} className={`relative overflow-hidden cursor-zoom-in group ${layout[i]}`} data-testid={`${testId}-photo-${i}`}>
            <img src={mediaUrl(src)} alt={`${title} — foto ${i + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          </button>
        ))}
      </div>
      <button onClick={() => onOpen(0)} className="absolute bottom-4 right-4 bg-white text-slate-900 text-sm font-bold px-4 py-2 rounded-full shadow-lg flex items-center gap-2" data-testid={`${testId}-all`}>
        <Images size={16} /> Ver todas as {images.length} fotos
      </button>
    </div>
  );
};

export const ShareBar = ({ shareUrl, text, testPrefix }) => {
  const copy = async (msg) => { await navigator.clipboard.writeText(shareUrl); toast.success(msg); };
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title: text, text, url: shareUrl }); } catch { /* cancelado */ } }
    else copy("Link copiado!");
  };
  const btn = "flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-bold transition-colors";
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testPrefix}-share`}>
      <button onClick={share} className={`${btn} bg-slate-900 text-white hover:bg-slate-700`} data-testid={`${testPrefix}-share-native`}><Share2 size={16} /> Compartilhar</button>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${shareUrl}`)}`} target="_blank" rel="noreferrer" className={`${btn} bg-[#25D366] text-white`} data-testid={`${testPrefix}-share-whatsapp`}><MessageCircle size={16} /> WhatsApp</a>
      <button onClick={() => copy("Link copiado! Cole nos Stories (figurinha Link) ou na bio do Instagram.")} className={`${btn} bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white`} data-testid={`${testPrefix}-share-instagram`}>
        <Instagram size={16} /> Link para o Instagram
      </button>
      <button onClick={() => copy("Link copiado!")} className={`${btn} border border-slate-200 text-slate-700 hover:bg-slate-50`} data-testid={`${testPrefix}-copy-link`}><Copy size={16} /> Copiar link</button>
    </div>
  );
};

export const shareLink = (kind, id) => `${process.env.REACT_APP_BACKEND_URL}/api/share/${kind}/${id}`;
